import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { layoutStyle } from "../pages/layout-ui/style";
import {
  getActiveSortRecord,
  onSortChanged,
} from "../common/utils/sortingColumn";

export const SortingTextPopup = ({
  open,
  setOpen,
  gridRef,
  setSortedColumn,
  setColumnFinal,
  sortableColumnData,
  createSortableColumn,
  updateViewSortableColumn,
  pageName,
}) => {
  const classes = layoutStyle();
  const activeSort = getActiveSortRecord(sortableColumnData);

  const handleClick = async () => {
    await onSortChanged(
      gridRef,
      setSortedColumn,
      setColumnFinal,
      sortableColumnData,
      createSortableColumn,
      updateViewSortableColumn,
      pageName,
      activeSort
    );
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {activeSort?.pageName === pageName
            ? "Do you want to override sorting on this page?"
            : activeSort
              ? `Do you want to replace the active sorting from ${activeSort.pageName} with this page's sorting?`
              : "Do you want to save sorting on this page?"}
        </DialogTitle>
        <DialogActions>
          <Button
            variant="outlined"
            type="submit"
            className={classes.deleteCancelButton}
            autoFocus
            onClick={handleClose}
          >
            No
          </Button>
          <Button
            variant="outlined"
            type="submit"
            className={classes.deleteOkButton}
            onClick={handleClick}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
